@if (isCreditBlocked) {
  <div class="alert alert-warning" role="alert" translate>
    CREDIT_BLOCKED_COLMEC
  </div>
}
<colmec-cart-list-buttons></colmec-cart-list-buttons>
<div class="row pb-2 pt-2 d-none d-md-flex cart-checkout-head">
  <div class="col-1"></div>
  <div class="d-none d-md-block col-md-2 text-center">
    <b translate>ITEM</b>
  </div>
  <div class="col-4 col-md-2 text-center">
    <b translate>QUANTITY</b>
  </div>
  <div class="col-4 col-md-2 text-center">
    <b translate>PRICE</b>
  </div>
  <div class="col-4 col-md-2  text-center">
    <b translate>NET_PRICE</b>
  </div>
  <div class="col-4 col-md-1 text-center">
    <b translate>DISCOUNT</b>
  </div>
  
  <div class="col-md-2 text-center">
    <b translate>TOTAL</b>
  </div>
</div>
<span *ngFor="let cartRow of data; trackBy: trackByFn">
  <colmec-sales-cart-row
    *ngIf="!isAdmin && cachedData[cartRow.productId]"
    [data]="{
      cartRow: cartRow,
      product: cachedData[cartRow.productId].product,
      availability: cachedData[cartRow.productId].availability,
      price: cachedData[cartRow.productId].price
    }"
  >
  </colmec-sales-cart-row>

  <colmec-admin-cart-row
    *ngIf="isAdmin && cachedData[cartRow.productId]"
    [data]="{
      cartRow: cartRow,
      product: cachedData[cartRow.productId].product,
      availability: cachedData[cartRow.productId].availability,
      price: cachedData[cartRow.productId].price
    }"
  ></colmec-admin-cart-row>
</span>
